/**
 * Fetch the validation rules from the backend and merge them over our own defaults - for both apps.
 *
 * The values in config.common.js are FALLBACKS, not the truth: if the backend is unreachable the app keeps
 * working with the numbers it shipped with. When the backend does answer, its numbers win, because it is the
 * side that actually enforces them. Each app asks through its own client: LIQUIDO through the team client,
 * Polly through the polly client - `query liquidoConfig` needs no login.
 *
 * @param {Function} fetchConfig () => Promise of the backend's settings
 * @returns {Promise<Boolean>} true once the settings are merged, false when the backend did not answer
 */
import config from "config"
import log from "loglevel"

export function loadBackendConfig(fetchConfig) {
	return fetchConfig()
		.then(settings => {
			Object.assign(config, settings)
			log.debug("Loaded settings from backend", settings)
			return true
		})
		.catch(err => {
			console.warn("Cannot load settings from backend, keeping local defaults", err)
			return false
		})
}
